import { Box, Grid, Typography } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'

import sparckLogo from 'assets/images/sparck-full-colored.png'
import { useCompany } from 'contexts'
import { ROUTES_PATHS } from 'core/routes'

type Props = {
  isMobile?: boolean
}

export default function TopbarLogo({ isMobile }: Props) {
  const { company } = useCompany()!
  const companyLogoUrl = company?.logo?.url

  return (
    <RouterLink to={ROUTES_PATHS.dashboard}>
      <Grid
        container
        direction="column"
        alignItems="center"
        style={{ display: 'inherit' }}
      >
        <Box
          height={isMobile ? 35 : 40}
          component="img"
          src={companyLogoUrl ? companyLogoUrl : sparckLogo}
          alt={companyLogoUrl ? 'Company logo' : 'Sparck logo'}
          sx={{ objectFit: 'contain', maxWidth: isMobile ? 140 : 180 }}
        />
        {companyLogoUrl && (
          <Typography variant="caption" sx={{ color: 'text.secondary' }}>
            Powered by Sparck
          </Typography>
        )}
      </Grid>
    </RouterLink>
  )
}
